import moment from "moment";
import { endpoint } from "../../../common/constant";
import {
  fetchAllPromisedData,
  updateRequest,
} from "../../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../../common/utils/methods/toasterFunctions/function";
import {
  getPaidItemListApi,
  formatPaidItemType,
} from "../../studentCharges/studentChargesDetails/concessionDetails/common";

export const getSchemesDropdown = (arr) => {
  return arr.map((item) => ({
    ...item,
    schemeValue: item?.value,
    label: item?.value,
    value: item?.id,
  }));
};

const getTotalPaidForLatestQuotation = async (
  applicationId,
  applicationQuotationDetailsId
) => {
  const response = await getPaidItemListApi({
    applicationId,
    applicationQuotationDetailsId,
  });
  return formatPaidItemType(response)?.reduce(
    (acc, curr) => acc + curr?.paidAmount,
    0
  );
};

export const fetchData = async (
  applicationId,
  quotationDetailsId,
  schemes,
  setLoader,
  isOldQuotationId = false,
  psid,
  businessAreasDisplay
) => {
  setLoader(true);
  const p = await Promise.all([
    fetchAllPromisedData(
      `${endpoint.applicationQuotationDetails}/${applicationId}${
        isOldQuotationId === "old"
          ? `?applicationQuotationId=${quotationDetailsId}`
          : ""
      }`
    ),
    fetchAllPromisedData(
      `${endpoint.deliveryOrder.deliveryOrderDetails}/${quotationDetailsId}`,
      false,
      false
    ),
  ]);
  setLoader(false);
  const paymentDetails = await fetchPaymentDetail(
    applicationId,
    quotationDetailsId,
    psid,
    businessAreasDisplay
  );
  const selectedScheme = schemes?.find(
    (item) => item?.id === p[0]?.loanSchemeMasterId
  );
  // const finalFinalCourseFee = isOldQuotationId === "old" ? p[1]?.finalCourseFee : p[0]?.totalNetPayable
  // const totalChargesAlreadyPaid = isOldQuotationId === "old" ? p[1]?.totalChargesAlreadyPaid : await getTotalPaidForLatestQuotation(applicationId, quotationDetailsId);
  // const finalFinalCourseFee = isOldQuotationId === "old" ? p[1]?.finalCourseFee : response?.data?.reduce((acc, curr) => acc + curr?.netPayable, 0);
  // const totalChargesAlreadyPaid = isOldQuotationId === "old" ? p[1]?.totalChargesAlreadyPaid : response?.data?.reduce((acc, curr) => acc + curr?.paidAmount, 0);
  const finalCourseFeeFromDO = p[1]?.finalCourseFee ?? 0;
  const finalCourseFeeFromPayment = paymentDetails?.applicationNetPayable ?? 0;
  const totalChargesAlreadyPaidFromDO = p[1]?.totalChargesAlreadyPaid ?? 0;
  const totalChargesAlreadyPaidFromPayment =
    paymentDetails?.applicationPaidAmount ?? 0;

  return {
    quotationDetailsId: quotationDetailsId,
    loanSchemeMasterId: selectedScheme,
    updatedProcessingFees : p[1]?.processingCharges ?? selectedScheme?.processingFees,
    loanVendorName: selectedScheme?.vendorName,
    // finalCourseFee: isOldQuotationId === "old" ? finalCourseFeeFromBE : finalCourseFeeCalculated,
    // totalChargesAlreadyPaid: isOldQuotationId === "old" ? totalChargesAlreadyPaidFromBE : totalChargesAlreadyPaidCalculated,
    finalCourseFeeFromDO,
    finalCourseFeeFromPayment,
    totalChargesAlreadyPaidFromDO,
    totalChargesAlreadyPaidFromPayment,
    netLoanAmount: p[1]?.netLoanAmount ?? "",
    parentPayingNow: p[1]?.parentPayingNow ?? "",
    doDate: p[1]?.doDate ?? "",
    doId: p[1]?.doId ?? "",
    doDocKey: p[1]?.doDocKey ?? "",
    updatedBy: p[1]?.updatedBy ?? "",
    updatedOn: p[1]?.updatedOn ?? "",
    createdBy: p[1]?.createdBy ?? "",
    createdOn: p[1]?.createdOn ?? "",
    isNew: !p[1],
    loanTransactionId: p[1]?.id,
  };
};

export const getFileName = ({ updatedOn }) =>
  `DO_Details_${moment(updatedOn).format("DD-MM-YYYY_hh:mm")}`;

const getPQ = (loanSchemeMasterId) => {
  const t = loanSchemeMasterId?.schemeValue?.split("/");
  return { P: t?.[0], Q: t?.[1] };
};

export const getGrossLoanAmount = ({
  finalCourseFee,
  netLoanAmount,
  loanSchemeMasterId,
  parentPayingNow,
  totalChargesAlreadyPaid,
}) => {
  const { P, Q } = getPQ(loanSchemeMasterId);
  return ((+netLoanAmount * P) / (P - Q)).toFixed(2);
};

export const getAdvanceEmi = ({
  finalCourseFee,
  netLoanAmount,
  loanSchemeMasterId,
  parentPayingNow,
  totalChargesAlreadyPaid,
}) => {
  const { P, Q } = getPQ(loanSchemeMasterId);
  // console.log(P, 'p', Q, 'Q')
  return ((+netLoanAmount * Q) / (P - Q)).toFixed(2);
};

export const getLoanNotApproved = ({
  finalCourseFee,
  netLoanAmount,
  loanSchemeMasterId,
  parentPayingNow,
  totalChargesAlreadyPaid,
}) => {
  const { P, Q } = getPQ(loanSchemeMasterId);
  // console.log('A', finalCourseFee, 'B', +netLoanAmount, 'D', (+netLoanAmount * Q) / (P - Q))
  // console.log((finalCourseFee - (+netLoanAmount) - ((+netLoanAmount * Q) / (P - Q))).toFixed(2))
  if (!netLoanAmount) return 0;
  return (
    finalCourseFee -
    +netLoanAmount -
    (+netLoanAmount * Q) / (P - Q)
  ).toFixed(2);
};

export const getProcessingFee = ({
  finalCourseFee,
  netLoanAmount,
  loanSchemeMasterId,
  parentPayingNow,
  totalChargesAlreadyPaid,
}) => {
  return loanSchemeMasterId?.processingFees;
};

export const getNetDisbursement = ({
  finalCourseFee,
  netLoanAmount,
  loanSchemeMasterId,
  parentPayingNow,
  totalChargesAlreadyPaid,
  updatedProcessingFees
}) => {
  if (!netLoanAmount) return 0;
  return (+netLoanAmount - updatedProcessingFees).toFixed(2);
};

export const getTotalUpfrontPayment = (doInformation) => {
  const { loanSchemeMasterId, parentPayingNow, updatedProcessingFees } = doInformation;
  return (
    getBalancePayable(doInformation) +
    (+updatedProcessingFees) +
    +parentPayingNow
  ).toFixed(2);
};

export const getBalancePayable = (doInformation) => {
  const advanceEmi = getAdvanceEmi(doInformation);
  const balancePayable = +advanceEmi - doInformation?.totalChargesAlreadyPaid;
  return balancePayable > 0 ? balancePayable : 0;
};

export const getCreateReqBody = (
  doInformation,
  applicationQuotationDetailsId
) => {
  return updateRequest({
    quotationDetailsId: applicationQuotationDetailsId,
    loanSchemeMasterId: doInformation?.loanSchemeMasterId,
    finalCourseFee: doInformation?.finalCourseFee,
    netLoanAmount: doInformation?.netLoanAmount,
    grossLoanAmount: getGrossLoanAmount(doInformation),
    advanceEmi: getAdvanceEmi(doInformation),
    loanNotApproved: getLoanNotApproved(doInformation),
    // processingCharges: getProcessingFee(doInformation),
    processingCharges : (doInformation?.updatedProcessingFees || 0),
    netDisbursement: getNetDisbursement(doInformation),
    totalChargesAlreadyPaid: doInformation?.totalChargesAlreadyPaid,
    balancePayable: getAdvanceEmi(doInformation),
    parentPayingNow: doInformation?.parentPayingNow || 0,
    totalUpfrontPaymentByParent: getTotalUpfrontPayment(doInformation),
    doDate: doInformation?.doDate,
    doId: doInformation?.doId,
    doDocKey: doInformation?.doDocKey,
    status: "ACTIVE",
  });
};
const getLoanPercentage = (schemeCode) => {
  if (!schemeCode) return 1;
  const [totalInstallments, downPayment] = schemeCode.split("/").map(Number);
  let loanPercentage = (totalInstallments - downPayment) / totalInstallments;
  loanPercentage = Math.ceil(loanPercentage * 100) / 100;
  return loanPercentage; 
};
export const isInvalidReqBody = (doInformation) => {
  const { finalCourseFee, netLoanAmount, loanSchemeMasterId, parentPayingNow } =
    doInformation;
  const { minimumAmount, vendorName, doIdLength, label } = loanSchemeMasterId;
  const loanNotApproved = getLoanNotApproved(doInformation);
  const maxLoanPercentage = getLoanPercentage(label);
  if (netLoanAmount > finalCourseFee * maxLoanPercentage) {
    failureToast(`Loan amount cannot be greater than ${maxLoanPercentage*100}% course fee amount`);
    return true;
  } else if (netLoanAmount < minimumAmount) {
    failureToast(
      `Minimum amount of Rs ${minimumAmount} is required to avail loan for ${vendorName}`
    );
    return true;
  } else if (+parentPayingNow > loanNotApproved) {
    failureToast("Please enter an amount less than Loan Not Approved");
    return true;
  } else if (doInformation?.doId?.length < doIdLength) {
    failureToast(`Please enter the DO id of minimum length ${doIdLength}`);
    return true;
  }

  return false;
};

export const getFileForm = (doInformation) => {
  return doInformation?.doDocKey
    ? {
        fileName: doInformation?.doFileName || getFileName(doInformation),
        s3key: doInformation?.doDocKey,
      }
    : {};
};

export const getFeeSummaryRow = (item, itemTypes, prevTotal) => {
  const res = {
    description:
      itemTypes?.find((o) => o?.itemTypeId === item?.itemType)?.description ||
      "-",
    baseFee: item?.grossAmount,
    concessionApplied: item?.concessionApplied,
    amountTotal: item?.netPayable,
    totalTaxes: item?.taxes,
    taxableAmount: item?.payableAmount,
    loanAmount: "",
    eligibilty: "",
    prevTotal: prevTotal,
  };

  return res;
};

export const fetchPaymentDetail = (
  applicationId,
  applicationQuotationDetailsId,
  psid,
  businessAreas
) => {
  return fetchAllPromisedData(
    `${endpoint.getApplicationNetPayable}/${applicationId}?psid=${psid}&businessArea=${businessAreas}&quotationId=${applicationQuotationDetailsId}`,
    false,
    false
  );
};
